<template>
    <div class="coverflow-swiper">
        <swiper class="swiper" :modules="modules" :pagination="true" :effect="'coverflow'" :grab-cursor="true"
            :centered-slides="true" :slides-per-view="'auto'" :coverflow-effect="{
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true
            }">
            <swiper-slide class="slide" v-for="doc in images" :key="doc.id">
                <img :src="'data:image/png;base64,' + doc.file_content" alt="Image" />
            </swiper-slide>
        </swiper>
    </div>
</template>

<script lang="ts" setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Pagination, EffectCoverflow } from 'swiper/modules'


const modules = [Pagination, EffectCoverflow];

interface Document {
    id: number;
    file_name: string;
    file_content: string;
    file_type: string;
    file_size: number;
    file_extension: string;
    file_path: string;
    file_url: string;
    file_description: string;
    created_at: string;
    updated_at: string;
}
defineProps({
    images: Array<Document>,
});
</script>

<style lang="scss" scoped>
.swiper {
    height: 100%;
    width: 100%;
    padding-top: 50px;
    padding-bottom: 50px;

    .slide {
        width: 60vw;
        height: 55vh;

        img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
}
.coverflow-swiper {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    margin: auto;
}
</style>